/**
 * GitLab — widget-first stránka.
 * Záložky a panely z module-ui-catalog (sdílené s Node workspace).
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';
import { useSearchParams } from 'react-router-dom';

const DEF = requireModuleUi('gitlab');

export default function GitlabPage() {
  const [params] = useSearchParams();
  const tab = params.get('tab');
  return <ModuleWorkspace def={DEF} hideHeader defaultTab={tab === 'workers' ? 'workers' : 'gitlab'} />;
}
